export default __webpack_public_path__ + "static/saasboomi_thumb-2aab2e9bcff38b7e04084d474615cee4.png";